<template>
    <div class="datafield-validation-action">
        <datafield-validation-statement
            :statement="action"
            :datafields="datafields"
            :show-comparator-operator="action.action === 'LIMIT'"
            :show-comparator-field="
                action.action === 'SET' || action.action === 'LIMIT'
            "
            :show-action="action.action === 'SET'"
            :validation-errors="validationErrors">
            <template v-slot:before>
                <uil-draggabledots />

                <!-- ACTION -->
                <ui5-select
                    @change="action.action = $event.detail.selectedOption.value"
                    :class="{ error: validationErrors.action.$error }">
                    <ui5-option :value="null" :selected="action.action == null">
                        ---
                    </ui5-option>
                    <ui5-option
                        v-for="a in actions"
                        :key="a"
                        :selected="action.action === a"
                        :value="a">
                        {{ a }}
                    </ui5-option>
                </ui5-select>
            </template>

            <template v-slot:after>
                <i @click="deleteAction()" class="fa fa-trash"></i>
            </template>
        </datafield-validation-statement>
    </div>
</template>
<script>
import DatafieldValidationStatement from './DatafieldValidationStatement.vue';
import { UilDraggabledots } from '@iconscout/vue-unicons';

export default {
    props: {
        action: {
            type: Object,
            required: true,
        },
        datafields: {
            type: Array,
            required: true,
        },
        validationErrors: {
            type: Object,
        },
    },
    data() {
        return {
            actions: ['ENABLE', 'DISABLE', 'HIDE', 'SHOW', 'SET', 'LIMIT'],
        };
    },
    methods: {
        deleteAction() {
            this.$emit('delete');
        },
    },
    components: {
        DatafieldValidationStatement,
        UilDraggabledots,
    },
};
</script>
